module.exports = __webpack_public_path__ + "static/media/HCMM717.a53fd5b7.jpg";